import React from 'react'
import defaultImg from "../../../assets/images/partners.png";
import { TbEdit } from "react-icons/tb";
import { useNavigate } from 'react-router';
import { MdOutlineEdit } from 'react-icons/md';
import { Privileges } from '../../../util/PrivilegeConstants';

const TeamCard = ({ team, handleOpenEditPopup, privileges }) => {
    const navigate = useNavigate();
    return (
        <div className='sm_team_card_con'>
            {privileges?.MANAGE_TEAM?.includes(Privileges.MODIFY) &&
                <MdOutlineEdit className='sm_team_card_edit_icon' onClick={() => handleOpenEditPopup(team)} />}
            <div className='sm_team_card_details'
                onClick={() => {
                    if (privileges?.MANAGE_TEAM?.includes(Privileges.MODIFY)) {
                        navigate("/team-players", {
                            state: {
                                teamId: team.teamId,
                                seasonId: team.seasonId
                            }
                        })
                    }
                }}>
                <div className='sm_team_card_img'>
                    <img src={team?.teamLogo ? `${import.meta.env.VITE_APP_BASE_URL}/team/logo/${team.teamLogo}` : defaultImg} alt="" />
                </div>
                <h2>{team?.teamName}</h2>
                <p>{team?.teamDesc}</p>
            </div>

        </div>
    )
}

export default TeamCard